import { DefaultService } from '@/services/DefaultService';


export default class CatalogoService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    uploadFile( file, catalogo ) {
        let data = new FormData();
        data.append("file", file);
        data.append("catalogo", new Blob([JSON.stringify( catalogo )],
        {
            type: "application/json"
        }));
        data.append("catalogo", catalogo);

        let requestOptions = {
            method: 'POST',
            headers: Object.assign(this._headers.headers),
            body: data
        }

        delete requestOptions.headers["Content-Type"];

        return this._http.post(`${this._env}/sales/catalog`, data, requestOptions).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err.body;
        });
    }

    removeFile( img ){
        return this._http.post(`${this._env}/sales/remove-image`, img, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err.body;
        });
    }

    updateImageData( images ){
        return this._http.post(`${this._env}/sales/update-images-details`, images, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err.body;
        });
    }

}